<template>
  <a
    :href="link"
    target="_blank">
    <icon
      :icon-name="site"
      :class="'social-icon__' + site"
      class="social-icon"
      view-box="0 0 24 24"/>
  </a>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";

export default {
  name: "SocialIcon",
  components: {
    Icon
  },
  props: {
    site: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  }
};
</script>
